export const variables = {
  YOUTOBE_REG_EXP: /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/,
  MAP_TOKEN: 'pk.eyJ1Ijoiam9obm5lb24iLCJhIjoiY2ttN2k4OTU3MGo2ajJwbGFiY3A2b3Y4aSJ9.wlYxrWsTtkIaoijDwil0tw',
  MAP_STYLE_LINK: 'mapbox://styles/johnneon/ckm7kyt6hg3ww17l94ba6ie94',
  WEATHER_API_KEY: 'eb7290df8210ec1e343811c44b869b32',
  EN: 'en',
  RU: 'ru',
  UA: 'ua',
  tSign: '°C',
  FULLNAME_REGEXP: /^[\w!#$%&'*+/=?^_`{|}~\- №"@]+$/,
  EMAIL_REGEXP: /^[\w!#$%&'*+/=?^_`{|}~]*(?:\.?[\w!#$%&'*+/=?^_`{|}~-]+)@[^.@]+\.[^.@]{2,}$/,
  PASSWORD_REGEXP: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,}$/,
  USER_DATA: 'userData',
}